export default __webpack_public_path__ + "static/media/BasicVideo2.629ec2eb.png";